<template>
  <div class="col-lg-12">
    <v-card color="grey darken-4">
      <google-map
        ref="gmap"
        :center="{ lat: -8.05, lng: -34.900002 }"
        :zoom="12"
        style="width: 100%; height: 440px"
      >
        <google-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          title="teste"
          :clickable="true"
          :draggable="false"
          @click="toggleInfoWindow(m)"
        />
        <google-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div class="">
            <div>
              <div>
                <div class="m-2">
                  <span style="color: #000"><b>ID:</b> {{ markerId }}</span>
                </div>
              </div>
              <div class="m-2">
                <span style="color: #000"
                  ><b>{{ $t("name") }}:</b> {{ markerName }}</span
                >
              </div>
            </div>
          </div>
        </google-info-window>
      </google-map>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "regional-manager-dashboard",
  data: () => ({
    markerId: "",
    markerName: "",
    markers: [],
    infoContent: "",
    infoWindowPos: {
      lat: 0,
      lng: 0,
    },
    infoWinOpen: false,
    infoOptions: {
      pixelOffset: {
        width: 0,
        height: -35,
      },
    },
  }),

  async created() {
    const request = await this.$request.get(
      "/regionalManager/dashboard/getGeoLocations"
    );

    this.markers = await request.dados.map((item) => ({
      id: item.id_agent,
      name: item.name,
      position: {
        lat: Number(item.lat),
        lng: Number(item.lng),
      },
    }));
  },

  methods: {
    toggleInfoWindow(marker) {
      this.markerId = marker.id;
      this.markerName = marker.name;
      this.infoWinOpen = true;
      this.infoWindowPos = marker.position;
    },
  },
};
</script>
